import { IntlFormatters } from 'react-intl';

export default function (intl: IntlFormatters, label: string, shortName: string | undefined): string | undefined {
  if (!shortName) return undefined;

  return intl.formatMessage(
    { id: 'inputs.chooseWithTeam' },
    {
      label,
      team: shortName,
    },
  );
}
